import Column from '@components/Column';
import InfinityScrollTrigger from '@components/InfinityScrollTrigger';
import Loading from '@components/Loading';
import Text from '@components/Text';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';

import useStampHistories from './hooks/useStampHistories';
import StampHistory from './StampHistory';

function StampHistories() {
    const { t } = useTranslation('stamp');
    const {
        histories, fetchNextPage, isFetching, enabled,
    } = useStampHistories();
    if (!enabled || histories?.length === 0) {
        return null;
    }
    return (
        <Container fullWidth spacing={16}>
            <Text size='lg' fontWeight='medium'>
                {t('histories.title')}
            </Text>
            <Column fullWidth spacing={8}>
                {histories?.map((history, idx) => (
                    <StampHistory history={history}
                        key={`history_${idx}`} />
                ))}
                {isFetching && (
                    <Loading size='small'/>
                )}
                <InfinityScrollTrigger trigger={fetchNextPage} />
            </Column>
        </Container>
    );
}

const Container = styled(Column)`
    padding: 0 16px;
`;

export default StampHistories;
